"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CtaButton_1 = require("../common/Btn/CtaButton");
var claims_1 = require("../../utils/shopify-graphql/claims");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var media_query_1 = require("../../hooks/media-query");
var Parser_1 = require("../Parser");
var color_1 = require("../common/color");
var ClaimsV2_1 = require("../ClaimsV2/ClaimsV2");
var Claims = function () {
    var _a;
    var _b = (0, hooks_1.useState)(null), data = _b[0], setData = _b[1];
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, claims_1.getClaimsData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    if (data.version == 'uro-vp-45') {
        return (0, preact_1.h)(ClaimsV2_1.default, { data: data });
    }
    else {
        return ((0, preact_1.h)("div", { className: "claims ".concat(data.version ? 'claims--' + data.version : ''), style: isDesktop
                ? { backgroundImage: "url(".concat(data.desktopImage, ")") }
                : { backgroundImage: "url(".concat(data.mobileImage, ")") } },
            (0, preact_1.h)("div", { className: "claims__main" },
                (0, preact_1.h)("p", { className: "claims__eyebrow", style: { color: (0, color_1.toHex)(data.textColor || 'charcoal') } }, data.eyebrow && (0, Parser_1.parse)(data.eyebrow)),
                (0, preact_1.h)("p", { className: "claims__header ".concat(data.smallerText ? 'smallerText' : ''), style: { color: (0, color_1.toHex)(data.color) } }, data.header && (0, Parser_1.parse)(data.header)),
                (0, preact_1.h)("p", { className: "claims__subheader", style: { color: (0, color_1.toHex)(data.textColor || 'charcoal') } }, data.subheader && (0, Parser_1.parse)(data.subheader)),
                (0, preact_1.h)("ul", { className: "claims__claim-list" }, (_a = data.claims) === null || _a === void 0 ? void 0 : _a.map(function (c) { return ((0, preact_1.h)("li", { className: "claims__claim", key: c.text },
                    c.image && (0, preact_1.h)("img", { src: c.image, className: "claims__claim-img" }),
                    (0, preact_1.h)("p", { className: "claims__claim-text", style: { color: (0, color_1.toHex)(data.textColor || 'charcoal') } }, (0, Parser_1.parse)(c.text)))); })),
                data.ctaColor && ((0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                        to: 'Left',
                        startColor: data.ctaColor.backgroundStart || 'white',
                        endColor: data.ctaColor.backgroundEnd,
                    }, hoverColor: data.ctaColor.hover, text: "SHOP NOW" })),
                (0, preact_1.h)("p", { className: "claims__disclaimer" }, (data === null || data === void 0 ? void 0 : data.disclaimer) && (0, Parser_1.parse)(data.disclaimer)))));
    }
};
exports.default = Claims;
